module.exports = __webpack_public_path__ + "media/images/restaurant gastronomique-18b9d6c15b0c453a622a3157480abbc2.svg";